import { Inspect } from '../../../../components/Inspect'
import {
  formatReviewString,
  replacePhraseWithString
} from '../../../../utilities'
import { healthcare_programs } from 'hotline_complaint_choices'

export const InspectHCF = ({ goBackToPage, pages, values }) => {
  const allegation_choices = require('../../../../choices/json/HCF_allegation.json')
  const program_choices = require('../../../../choices/json/HCF_hhs_program.json')
  const allegationDetails = []
  if (values.perm_to_disclose != 'Anonymous') {
    // If user is anonymous, clicking on edit for this field causes an error. So hide it.
    allegationDetails.push({
      heading: 'HHS employee, contractor, or grantee',
      field_name: 'complainant_hhs_employee',
      value: formatReviewString(values.complainant_hhs_employee)
    })
  }
  allegationDetails.push(
    {
      heading: 'Allegation type',
      field_name: 'allegation',
      value: formatReviewString(
        replacePhraseWithString(
          [allegation_choices[values.allegation]],
          values.allegation_other
        ).join(', ')
      )
    },
    {
      heading: 'Healthcare program',
      field_name: 'hhs_program',
      value: formatReviewString(
        replacePhraseWithString(
          [program_choices[values.hhs_program]],
          values.hhs_program_other
        ).join(', ')
      )
    },
    {
      heading: 'Program type',
      field_name: 'hhs_program_type',
      value: formatReviewString(
        replacePhraseWithString(
          [healthcare_programs[values.hhs_program_type]],
          values.hhs_program_type_other
        ).join(', ')
      )
    }
  )

  return Inspect({ goBackToPage, pages, values, allegationDetails })
}
